import { leadsConstants } from '../constants';

export const leadsReducer = (state = {}, action) => {
    switch(action.type) {
        case leadsConstants.GET_ALL_LEADS_REQUEST: 
            return {
                ...state,
                getAllLeadsProcess: true
            }

        case leadsConstants.GET_ALL_LEADS_FAILURE:
            return {
                ...state,
                getAllLeadsProcess: false,
                getAllLeadsError: true
            }
        
        case leadsConstants.GET_ALL_LEADS_SUCCESS:
            return {
                ...state,
                list: [...action.payload],
                getAllLeadsProcess: false,
                getAllLeadsError: false
            }

        case leadsConstants.UPDATE_LEAD_REQUEST: 
        {
            let {leadID} = action.payload;

            return {
                ...state,
                updateLeadProcessList: {...state.updateLeadProcessList, [leadID]: true}
            }
        }

        case leadsConstants.UPDATE_LEAD_FAILURE: 
        {
            let {leadID} = action.payload;

            return {
                ...state,
                updateLeadProcessList: {...state.updateLeadProcessList, [leadID]: false},
                updateLeadErrorList: {...state.updateLeadErrorList, [leadID]: true}
            }
        }

        case leadsConstants.UPDATE_LEAD_SUCCESS: 
        {
            var {_id} = action.payload;
            let allLeads = state.list || [];
            let updatedLeadList = allLeads.map((item) => {
                if(item._id === _id) return action.payload;
                return item;
            });

            return {
                ...state,
                list: updatedLeadList,
                updateLeadProcessList: {...state.updateLeadProcessList, [_id]: false},
                updateLeadErrorList: {...state.updateLeadErrorList, [_id]: false}
            }
        }  

        case leadsConstants.DELETE_LEAD_SUCCESS: 
        {
            let {leadID} = action.payload;
            let allLeads = state.list || [];
            let updatedLeadList = allLeads.filter((item) => {
                return item._id !== leadID;
            });

            return {
                ...state,
                list: updatedLeadList,
            }
        }

        default:
            return state;
    }
}

export default leadsReducer;


// WEBPACK FOOTER //
// ./src/reducers/leads.js